module.exports = __webpack_public_path__ + "img/rocket.1bfb9b83.png";